// extracted by mini-css-extract-plugin
export default {"wrap":"wrap-OgOf","mode":"mode-KpZZ","header":"header-y1cn","title":"title-Zv4m","actions":"actions-fOXm"};